module.exports = __webpack_public_path__ + "media/components/Builder/Library/Images/ChevronRight-6e5813d71ff05c607a320b99ef0c950a.png";